import React, { useState } from "react";
import { FaShoppingBag } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import { useCountry } from "./CountryContext";
import "./Mens.css";

/* =========================================
   IMAGES
========================================= */

import mens20 from "../Images/mens20.jpg";
import mens11 from "../Images/mens11.jpg";
import mens12 from "../Images/mens12.jpg";
import mens26 from "../Images/mens26.png";
import mens16 from "../Images/mens16.jpg";
import mens27 from "../Images/mens27.png";
import mens28 from "../Images/mens28.png";
import mens22 from "../Images/mens22.jpg";

import mens29 from "../Images/mens30.jpg";
import mens30 from "../Images/mens33.jpg";
import mens31 from "../Images/mens31.jpg";
import mens32 from "../Images/mens32.jpg";
import mens33 from "../Images/mens33.jpg";
import mens34 from "../Images/mens34.jpg";
import mens35 from "../Images/mens35.jpg";
import mens36 from "../Images/mens36.jpg";
import mens37 from "../Images/mens37.jpg";
import mens38 from "../Images/mens38.jpg";
import mens39 from "../Images/mens39.jpg";
import mens40 from "../Images/mens40.jpg";
import mens41 from "../Images/mens41.jpg";
import mens42 from "../Images/mens42.jpg";
import mens43 from "../Images/mens43.jpg";
import mens44 from "../Images/mens44.jpg";
import mens45 from "../Images/mens45.jpg";
import mens46 from "../Images/mens46.jpg";
import mens47 from "../Images/mens47.jpg";
import mens48 from "../Images/mens48.jpg";


/* =========================================
   MENS COMPONENT
========================================= */

function Mens() {

  const navigate = useNavigate();

  const { addToCart } = useCart();

  const { formatPrice } = useCountry();

  const [showAll, setShowAll] = useState(false);


  /* =========================================
     MENS PRODUCTS
  ========================================= */

  const mensItems = [

    {
      id: 201,
      name: "African Royal Print Shirt",
      img: mens20,
      price: 149.99,
      discount: 20,
    },

    {
      id: 202,
      name: "African Classic Men's Outfit",
      img: mens11,
      price: 159.99,
      discount: 15,
    },

    {
      id: 203,
      name: "Traditional African Shirt",
      img: mens12,
      price: 129.99,
      discount: 10,
    },

    {
      id: 204,
      name: "Luxury African Men's Wear",
      img: mens26,
      price: 189.99,
      discount: 25,
    },

    {
      id: 205,
      name: "African Premium Printed Set",
      img: mens16,
      price: 139.99,
      discount: 5,
    },

    {
      id: 206,
      name: "African Heritage Fashion",
      img: mens27,
      price: 169.99,
      discount: 30,
    },

    {
      id: 207,
      name: "Modern African Men's Style",
      img: mens28,
      price: 119.99,
      discount: 10,
    },

    {
      id: 208,
      name: "African Wedding Collection",
      img: mens22,
      price: 199.99,
      discount: 20,
    },

    /* =========================================
       EXTRA PRODUCTS
    ========================================= */

    {
      id: 209,
      name: "African Royal Occasion Wear",
      img: mens29,
      price: 179.99,
      discount: 15,
    },

    {
      id: 210,
      name: "African Luxury Pattern Suit",
      img: mens30,
      price: 219.99,
      discount: 20,
    },

    {
      id: 211,
      name: "Premium African Celebration Wear",
      img: mens31,
      price: 189.99,
      discount: 10,
    },

    {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens32,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens33,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens34,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens35,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens36,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens37,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens38,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens39,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens40,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens41,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens42,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens43,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens44,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens45,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens46,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens47,
      price: 229.99,
      discount: 25,
    },

     {
      id: 212,
      name: "Elegant African Men's Collection",
      img: mens48,
      price: 229.99,
      discount: 25,
    },

  ];


  /* =========================================
     VISIBLE PRODUCTS
  ========================================= */

  const visibleProducts = showAll
    ? mensItems
    : mensItems.slice(0, 8);


  /* =========================================
     DISCOUNT PRICE
  ========================================= */

  const getDiscountedPrice = (price, discount) => {

    return Number(
      (price - (price * discount) / 100).toFixed(2)
    );

  };


  /* =========================================
     ADD TO CART
  ========================================= */

  const handleAddToCart = (item) => {

    const discountedPrice = getDiscountedPrice(
      item.price,
      item.discount
    );

    addToCart({
      id: item.id,
      name: item.name,
      img: item.img,
      image: item.img,
      price: discountedPrice,
      oldPrice: item.price,
    });

    alert(`${item.name} added to cart!`);
  };


  /* =========================================
     BUY NOW
  ========================================= */

  const handleBuyNow = (item) => {

    const discountedPrice = getDiscountedPrice(
      item.price,
      item.discount
    );

    addToCart({
      id: item.id,
      name: item.name,
      img: item.img,
      image: item.img,
      price: discountedPrice,
      oldPrice: item.price,
    });

    navigate("/payment");
  };


  /* =========================================
     JSX
  ========================================= */

  return (

    <div className="mens-page">

      {/* =====================================
          HEADING
      ===================================== */}

      <section className="mens-heading-section">

        <p className="mens-small-title">
          FASHION AFRIQUE
        </p>

        <h1 className="mens-main-title">
          Men’s Collection
        </h1>

        <div className="mens-heading-line"></div>

        <p className="mens-subtitle">
          Discover premium African men's fashion,
          designed with timeless patterns, rich fabrics
          and modern African elegance.
        </p>

      </section>


      {/* =====================================
          PRODUCTS
      ===================================== */}

      <div className="container mens-products-container">

        <div className="row g-4">

          {visibleProducts.map((item) => {

            const discountedPrice = getDiscountedPrice(
              item.price,
              item.discount
            );

            return (

              <div
                className="col-6 col-lg-3"
                key={item.id}
              >

                <div className="mens-product-card">

                  {/* IMAGE */}

                  <div className="mens-image-box">

                    <img
                      src={item.img}
                      alt={item.name}
                      className="mens-product-image"
                    />

                    <span className="mens-discount">
                      {item.discount}% OFF
                    </span>

                  </div>


                  {/* DETAILS */}

                  <div className="mens-product-details">

                    <h3 className="mens-product-name">
                      {item.name}
                    </h3>


                    {/* PRICE */}

                    <div className="mens-price-section">

                      <span className="mens-current-price">
                        {formatPrice(discountedPrice)}
                      </span>

                      <span className="mens-old-price">
                        <del>
                          {formatPrice(item.price)}
                        </del>
                      </span>

                    </div>


                    {/* BUTTONS */}

                    <div className="mens-buttons">

                      <button
                        type="button"
                        className="mens-cart-btn"
                        onClick={() =>
                          handleAddToCart(item)
                        }
                      >

                        <FaShoppingBag />

                        <span>
                          Add to Cart
                        </span>

                      </button>


                      <button
                        type="button"
                        className="mens-buy-btn"
                        onClick={() =>
                          handleBuyNow(item)
                        }
                      >
                        Buy Now
                      </button>

                    </div>

                  </div>

                </div>

              </div>

            );

          })}

        </div>

      </div>


      {/* =====================================
          VIEW ALL BUTTON
      ===================================== */}

      <div className="mens-view-all-section">

        <button
          type="button"
          className="mens-view-all-btn"
          onClick={() =>
            setShowAll((previous) => !previous)
          }
        >

          {showAll
            ? "Show Less"
            : "View All Mens Collection"}

        </button>

      </div>

    </div>

  );
}

export default Mens;

